<template>
  <div class="news-rank-pack">
    <div class="news-rank-wrapper" style="margin-top: -22px;">
      <ul class="rt-site clearfix" style="display: none;"></ul>
      <AdsChuchuang v-bind:pageType="pageType"></AdsChuchuang>
      <div class="rank-title">
        <span>娱乐八卦</span>
      </div>
      <EntNews v-bind:compsCfg="compsCfg.EntNews" v-bind:compName="compName" v-bind:pageType="pageType"></EntNews>
    </div>
  </div>
</template>
<script>
import AdsChuchuang from './RightNews/AdsChuchuang';
import EntNews from './RightNews/EntNews';

export default {
  name: 'RightNews',
  components: {
    AdsChuchuang,
    EntNews
  },
  data () {
    return {
      compName: 'RightNews'
    };
  },
  props: [
    'compsCfg', 'pageType'
  ]
}
</script>
